<template>
  <div id class="itle">
    <div class="iten_title">{{ articles.title }}</div>
    <div class="itemdz">
      <div id class="itemimg">
        <img src="../assets/activity_time.png" /> {{ articles.pubtime }}
      </div>
      <div id class="itemimg">
        <img src="../assets/activity_dizhi.png" />香山革命纪念馆
      </div>
    </div>

    <div class="itemhtml" v-html="articles.content"></div>
  </div>
</template>

<script>
import { wclient } from "../../static/wclient-mobile.js";
export default {
  name: "PersonalCenter",
  data() {
    return {
      baseUrl: "",
      orderlist: "",
      inde: "10",
      articles: [],
      index: 0,
      articleid: ""
    };
  },
  methods: {
    article() {
      var that = this;
      wclient.view.showLoading();
      that.$http
        .get(
          that.baseUrl +
            "?ugi=article&action=get&moduleid=PORTAL&articleid=" +
            that.articleid,
          {}
        )
        .then(function(res) {
          wclient.view.hideLoading();
          that.articles = res.data.article;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  mounted() {
    var that = this;
    var publicUrl = window.location.hostname;
    if (publicUrl == "localhost") {
      var baseUrl = "http://xs.weapi.org/ajax";
    } else if (publicUrl == "m.xs.weapi.org") {
      var baseUrl = "http://xs.weapi.org/ajax";
    } else {
      var baseUrl = "https://www.xiangshan1949.cn/ajax";
    }
    this.articleid = this.$route.query.articleid;
    that.baseUrl = baseUrl;
    wclient.view.showLoading();
    that.article();
  }
};
</script>

<style scoped>
.itle {
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;
}

.iten_title {
  color: #181818;
  font-size: 20px;
  font-weight: bold;
  color: rgba(24, 24, 24, 1);
}

.itemhtml {
  width: 100%;
  margin: 0 auto;
  background: #eee;
}

.itemhtml >>> p {
  line-height: 30px;
  margin: 10px 0;
  color: #000000;
  font-size: 16px;
}

.itemimg {
  display: flex;
  align-items: center;
  color: #7f7f7f;
  line-height: 30px;
}

.itemimg img {
  width: 16px;
  margin-right: 3px;
}

.itemdz {
  margin: 10px 0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/articleitem.vue